/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppChar126offlineRouteImport } from './routes/_app/~offline'
import { Route as AppUpdateRouteImport } from './routes/_app/update'
import { Route as AppSessionsRouteImport } from './routes/_app/sessions'
import { Route as AppRequestpasswordRouteImport } from './routes/_app/requestpassword'
import { Route as AppRegistermemberRouteImport } from './routes/_app/registermember'
import { Route as AppProductsRouteImport } from './routes/_app/products'
import { Route as AppCoursesRouteImport } from './routes/_app/courses'
import { Route as AppArticlegroupsRouteImport } from './routes/_app/articlegroups'
import { Route as AppAllotmentsRouteImport } from './routes/_app/allotments'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as AppAccessibilityRouteImport } from './routes/_app/accessibility'
import { Route as AppSplatRouteImport } from './routes/_app/$'
import { Route as AppSessionsIndexRouteImport } from './routes/_app/sessions/index'
import { Route as AppProductsIndexRouteImport } from './routes/_app/products/index'
import { Route as AppCoursesIndexRouteImport } from './routes/_app/courses/index'
import { Route as AppCookiesIndexRouteImport } from './routes/_app/cookies/index'
import { Route as AppArticlegroupsIndexRouteImport } from './routes/_app/articlegroups/index'
import { Route as AppAllotmentsIndexRouteImport } from './routes/_app/allotments/index'
import { Route as AppAccountIndexRouteImport } from './routes/_app/account/index'
import { Route as AppSetpasswordIdRouteImport } from './routes/_app/setpassword/$id'
import { Route as AppSessionsIdRouteImport } from './routes/_app/sessions/$id'
import { Route as AppSaleTokenRouteImport } from './routes/_app/sale/$token'
import { Route as AppProductsPluRouteImport } from './routes/_app/products/$plu'
import { Route as AppCoursesIdRouteImport } from './routes/_app/courses/$id'
import { Route as AppArticlegroupsIdRouteImport } from './routes/_app/articlegroups/$id'
import { Route as AppAllotmentsIdRouteImport } from './routes/_app/allotments/$id'
import { Route as AppAccountRegisterRouteImport } from './routes/_app/account/register'
import { Route as AppAccountCompletedregistrationRouteImport } from './routes/_app/account/completedregistration'
import { Route as AppAccountAuthRouteImport } from './routes/_app/account/_auth'
import { Route as AppArticlegroupsIdIndexRouteImport } from './routes/_app/articlegroups/$id/index'
import { Route as AppArticlegroupsIdPluRouteImport } from './routes/_app/articlegroups/$id/$plu'
import { Route as AppAccountAuthTicketsRouteImport } from './routes/_app/account/_auth/tickets'
import { Route as AppAccountAuthSubscriptionsRouteImport } from './routes/_app/account/_auth/subscriptions'
import { Route as AppAccountAuthRegistermanagedRouteImport } from './routes/_app/account/_auth/registermanaged'
import { Route as AppAccountAuthPhotoRouteImport } from './routes/_app/account/_auth/photo'
import { Route as AppAccountAuthPasswordRouteImport } from './routes/_app/account/_auth/password'
import { Route as AppAccountAuthHistoryRouteImport } from './routes/_app/account/_auth/history'
import { Route as AppAccountAuthCustomerinfoRouteImport } from './routes/_app/account/_auth/customerinfo'
import { Route as AppAccountAuthBookingsRouteImport } from './routes/_app/account/_auth/bookings'
import { Route as AppAccountAuthActivateticketRouteImport } from './routes/_app/account/_auth/activateticket'
import { Route as AppAccountAuthUserSlugRouteImport } from './routes/_app/account/_auth/user/$slug'

const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppChar126offlineRoute = AppChar126offlineRouteImport.update({
  id: '/~offline',
  path: '/~offline',
  getParentRoute: () => AppRoute,
} as any)
const AppUpdateRoute = AppUpdateRouteImport.update({
  id: '/update',
  path: '/update',
  getParentRoute: () => AppRoute,
} as any)
const AppSessionsRoute = AppSessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => AppRoute,
} as any)
const AppRequestpasswordRoute = AppRequestpasswordRouteImport.update({
  id: '/requestpassword',
  path: '/requestpassword',
  getParentRoute: () => AppRoute,
} as any)
const AppRegistermemberRoute = AppRegistermemberRouteImport.update({
  id: '/registermember',
  path: '/registermember',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsRoute = AppProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AppRoute,
} as any)
const AppCoursesRoute = AppCoursesRouteImport.update({
  id: '/courses',
  path: '/courses',
  getParentRoute: () => AppRoute,
} as any)
const AppArticlegroupsRoute = AppArticlegroupsRouteImport.update({
  id: '/articlegroups',
  path: '/articlegroups',
  getParentRoute: () => AppRoute,
} as any)
const AppAllotmentsRoute = AppAllotmentsRouteImport.update({
  id: '/allotments',
  path: '/allotments',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppAccessibilityRoute = AppAccessibilityRouteImport.update({
  id: '/accessibility',
  path: '/accessibility',
  getParentRoute: () => AppRoute,
} as any)
const AppSplatRoute = AppSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AppRoute,
} as any)
const AppSessionsIndexRoute = AppSessionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSessionsRoute,
} as any)
const AppProductsIndexRoute = AppProductsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppProductsRoute,
} as any)
const AppCoursesIndexRoute = AppCoursesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCoursesRoute,
} as any)
const AppCookiesIndexRoute = AppCookiesIndexRouteImport.update({
  id: '/cookies/',
  path: '/cookies/',
  getParentRoute: () => AppRoute,
} as any)
const AppArticlegroupsIndexRoute = AppArticlegroupsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppArticlegroupsRoute,
} as any)
const AppAllotmentsIndexRoute = AppAllotmentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAllotmentsRoute,
} as any)
const AppAccountIndexRoute = AppAccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppSetpasswordIdRoute = AppSetpasswordIdRouteImport.update({
  id: '/setpassword/$id',
  path: '/setpassword/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSessionsIdRoute = AppSessionsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppSessionsRoute,
} as any)
const AppSaleTokenRoute = AppSaleTokenRouteImport.update({
  id: '/sale/$token',
  path: '/sale/$token',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsPluRoute = AppProductsPluRouteImport.update({
  id: '/$plu',
  path: '/$plu',
  getParentRoute: () => AppProductsRoute,
} as any)
const AppCoursesIdRoute = AppCoursesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppCoursesRoute,
} as any)
const AppArticlegroupsIdRoute = AppArticlegroupsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppArticlegroupsRoute,
} as any)
const AppAllotmentsIdRoute = AppAllotmentsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppAllotmentsRoute,
} as any)
const AppAccountRegisterRoute = AppAccountRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppAccountCompletedregistrationRoute =
  AppAccountCompletedregistrationRouteImport.update({
    id: '/completedregistration',
    path: '/completedregistration',
    getParentRoute: () => AppAccountRoute,
  } as any)
const AppAccountAuthRoute = AppAccountAuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppArticlegroupsIdIndexRoute = AppArticlegroupsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppArticlegroupsIdRoute,
} as any)
const AppArticlegroupsIdPluRoute = AppArticlegroupsIdPluRouteImport.update({
  id: '/$plu',
  path: '/$plu',
  getParentRoute: () => AppArticlegroupsIdRoute,
} as any)
const AppAccountAuthTicketsRoute = AppAccountAuthTicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => AppAccountAuthRoute,
} as any)
const AppAccountAuthSubscriptionsRoute =
  AppAccountAuthSubscriptionsRouteImport.update({
    id: '/subscriptions',
    path: '/subscriptions',
    getParentRoute: () => AppAccountAuthRoute,
  } as any)
const AppAccountAuthRegistermanagedRoute =
  AppAccountAuthRegistermanagedRouteImport.update({
    id: '/registermanaged',
    path: '/registermanaged',
    getParentRoute: () => AppAccountAuthRoute,
  } as any)
const AppAccountAuthPhotoRoute = AppAccountAuthPhotoRouteImport.update({
  id: '/photo',
  path: '/photo',
  getParentRoute: () => AppAccountAuthRoute,
} as any)
const AppAccountAuthPasswordRoute = AppAccountAuthPasswordRouteImport.update({
  id: '/password',
  path: '/password',
  getParentRoute: () => AppAccountAuthRoute,
} as any)
const AppAccountAuthHistoryRoute = AppAccountAuthHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => AppAccountAuthRoute,
} as any)
const AppAccountAuthCustomerinfoRoute =
  AppAccountAuthCustomerinfoRouteImport.update({
    id: '/customerinfo',
    path: '/customerinfo',
    getParentRoute: () => AppAccountAuthRoute,
  } as any)
const AppAccountAuthBookingsRoute = AppAccountAuthBookingsRouteImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => AppAccountAuthRoute,
} as any)
const AppAccountAuthActivateticketRoute =
  AppAccountAuthActivateticketRouteImport.update({
    id: '/activateticket',
    path: '/activateticket',
    getParentRoute: () => AppAccountAuthRoute,
  } as any)
const AppAccountAuthUserSlugRoute = AppAccountAuthUserSlugRouteImport.update({
  id: '/user/$slug',
  path: '/user/$slug',
  getParentRoute: () => AppAccountAuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/callback': typeof CallbackRoute
  '/$': typeof AppSplatRoute
  '/accessibility': typeof AppAccessibilityRoute
  '/account': typeof AppAccountRouteWithChildren
  '/allotments': typeof AppAllotmentsRouteWithChildren
  '/articlegroups': typeof AppArticlegroupsRouteWithChildren
  '/courses': typeof AppCoursesRouteWithChildren
  '/products': typeof AppProductsRouteWithChildren
  '/registermember': typeof AppRegistermemberRoute
  '/requestpassword': typeof AppRequestpasswordRoute
  '/sessions': typeof AppSessionsRouteWithChildren
  '/update': typeof AppUpdateRoute
  '/~offline': typeof AppChar126offlineRoute
  '/account/completedregistration': typeof AppAccountCompletedregistrationRoute
  '/account/register': typeof AppAccountRegisterRoute
  '/allotments/$id': typeof AppAllotmentsIdRoute
  '/articlegroups/$id': typeof AppArticlegroupsIdRouteWithChildren
  '/courses/$id': typeof AppCoursesIdRoute
  '/products/$plu': typeof AppProductsPluRoute
  '/sale/$token': typeof AppSaleTokenRoute
  '/sessions/$id': typeof AppSessionsIdRoute
  '/setpassword/$id': typeof AppSetpasswordIdRoute
  '/account/': typeof AppAccountIndexRoute
  '/allotments/': typeof AppAllotmentsIndexRoute
  '/articlegroups/': typeof AppArticlegroupsIndexRoute
  '/cookies/': typeof AppCookiesIndexRoute
  '/courses/': typeof AppCoursesIndexRoute
  '/products/': typeof AppProductsIndexRoute
  '/sessions/': typeof AppSessionsIndexRoute
  '/account/activateticket': typeof AppAccountAuthActivateticketRoute
  '/account/bookings': typeof AppAccountAuthBookingsRoute
  '/account/customerinfo': typeof AppAccountAuthCustomerinfoRoute
  '/account/history': typeof AppAccountAuthHistoryRoute
  '/account/password': typeof AppAccountAuthPasswordRoute
  '/account/photo': typeof AppAccountAuthPhotoRoute
  '/account/registermanaged': typeof AppAccountAuthRegistermanagedRoute
  '/account/subscriptions': typeof AppAccountAuthSubscriptionsRoute
  '/account/tickets': typeof AppAccountAuthTicketsRoute
  '/articlegroups/$id/$plu': typeof AppArticlegroupsIdPluRoute
  '/articlegroups/$id/': typeof AppArticlegroupsIdIndexRoute
  '/account/user/$slug': typeof AppAccountAuthUserSlugRoute
}
export interface FileRoutesByTo {
  '/callback': typeof CallbackRoute
  '/$': typeof AppSplatRoute
  '/accessibility': typeof AppAccessibilityRoute
  '/registermember': typeof AppRegistermemberRoute
  '/requestpassword': typeof AppRequestpasswordRoute
  '/update': typeof AppUpdateRoute
  '/~offline': typeof AppChar126offlineRoute
  '/': typeof AppIndexRoute
  '/account': typeof AppAccountIndexRoute
  '/account/completedregistration': typeof AppAccountCompletedregistrationRoute
  '/account/register': typeof AppAccountRegisterRoute
  '/allotments/$id': typeof AppAllotmentsIdRoute
  '/courses/$id': typeof AppCoursesIdRoute
  '/products/$plu': typeof AppProductsPluRoute
  '/sale/$token': typeof AppSaleTokenRoute
  '/sessions/$id': typeof AppSessionsIdRoute
  '/setpassword/$id': typeof AppSetpasswordIdRoute
  '/allotments': typeof AppAllotmentsIndexRoute
  '/articlegroups': typeof AppArticlegroupsIndexRoute
  '/cookies': typeof AppCookiesIndexRoute
  '/courses': typeof AppCoursesIndexRoute
  '/products': typeof AppProductsIndexRoute
  '/sessions': typeof AppSessionsIndexRoute
  '/account/activateticket': typeof AppAccountAuthActivateticketRoute
  '/account/bookings': typeof AppAccountAuthBookingsRoute
  '/account/customerinfo': typeof AppAccountAuthCustomerinfoRoute
  '/account/history': typeof AppAccountAuthHistoryRoute
  '/account/password': typeof AppAccountAuthPasswordRoute
  '/account/photo': typeof AppAccountAuthPhotoRoute
  '/account/registermanaged': typeof AppAccountAuthRegistermanagedRoute
  '/account/subscriptions': typeof AppAccountAuthSubscriptionsRoute
  '/account/tickets': typeof AppAccountAuthTicketsRoute
  '/articlegroups/$id/$plu': typeof AppArticlegroupsIdPluRoute
  '/articlegroups/$id': typeof AppArticlegroupsIdIndexRoute
  '/account/user/$slug': typeof AppAccountAuthUserSlugRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/callback': typeof CallbackRoute
  '/_app/$': typeof AppSplatRoute
  '/_app/accessibility': typeof AppAccessibilityRoute
  '/_app/account': typeof AppAccountRouteWithChildren
  '/_app/allotments': typeof AppAllotmentsRouteWithChildren
  '/_app/articlegroups': typeof AppArticlegroupsRouteWithChildren
  '/_app/courses': typeof AppCoursesRouteWithChildren
  '/_app/products': typeof AppProductsRouteWithChildren
  '/_app/registermember': typeof AppRegistermemberRoute
  '/_app/requestpassword': typeof AppRequestpasswordRoute
  '/_app/sessions': typeof AppSessionsRouteWithChildren
  '/_app/update': typeof AppUpdateRoute
  '/_app/~offline': typeof AppChar126offlineRoute
  '/_app/': typeof AppIndexRoute
  '/_app/account/_auth': typeof AppAccountAuthRouteWithChildren
  '/_app/account/completedregistration': typeof AppAccountCompletedregistrationRoute
  '/_app/account/register': typeof AppAccountRegisterRoute
  '/_app/allotments/$id': typeof AppAllotmentsIdRoute
  '/_app/articlegroups/$id': typeof AppArticlegroupsIdRouteWithChildren
  '/_app/courses/$id': typeof AppCoursesIdRoute
  '/_app/products/$plu': typeof AppProductsPluRoute
  '/_app/sale/$token': typeof AppSaleTokenRoute
  '/_app/sessions/$id': typeof AppSessionsIdRoute
  '/_app/setpassword/$id': typeof AppSetpasswordIdRoute
  '/_app/account/': typeof AppAccountIndexRoute
  '/_app/allotments/': typeof AppAllotmentsIndexRoute
  '/_app/articlegroups/': typeof AppArticlegroupsIndexRoute
  '/_app/cookies/': typeof AppCookiesIndexRoute
  '/_app/courses/': typeof AppCoursesIndexRoute
  '/_app/products/': typeof AppProductsIndexRoute
  '/_app/sessions/': typeof AppSessionsIndexRoute
  '/_app/account/_auth/activateticket': typeof AppAccountAuthActivateticketRoute
  '/_app/account/_auth/bookings': typeof AppAccountAuthBookingsRoute
  '/_app/account/_auth/customerinfo': typeof AppAccountAuthCustomerinfoRoute
  '/_app/account/_auth/history': typeof AppAccountAuthHistoryRoute
  '/_app/account/_auth/password': typeof AppAccountAuthPasswordRoute
  '/_app/account/_auth/photo': typeof AppAccountAuthPhotoRoute
  '/_app/account/_auth/registermanaged': typeof AppAccountAuthRegistermanagedRoute
  '/_app/account/_auth/subscriptions': typeof AppAccountAuthSubscriptionsRoute
  '/_app/account/_auth/tickets': typeof AppAccountAuthTicketsRoute
  '/_app/articlegroups/$id/$plu': typeof AppArticlegroupsIdPluRoute
  '/_app/articlegroups/$id/': typeof AppArticlegroupsIdIndexRoute
  '/_app/account/_auth/user/$slug': typeof AppAccountAuthUserSlugRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/callback'
    | '/$'
    | '/accessibility'
    | '/account'
    | '/allotments'
    | '/articlegroups'
    | '/courses'
    | '/products'
    | '/registermember'
    | '/requestpassword'
    | '/sessions'
    | '/update'
    | '/~offline'
    | '/account/completedregistration'
    | '/account/register'
    | '/allotments/$id'
    | '/articlegroups/$id'
    | '/courses/$id'
    | '/products/$plu'
    | '/sale/$token'
    | '/sessions/$id'
    | '/setpassword/$id'
    | '/account/'
    | '/allotments/'
    | '/articlegroups/'
    | '/cookies/'
    | '/courses/'
    | '/products/'
    | '/sessions/'
    | '/account/activateticket'
    | '/account/bookings'
    | '/account/customerinfo'
    | '/account/history'
    | '/account/password'
    | '/account/photo'
    | '/account/registermanaged'
    | '/account/subscriptions'
    | '/account/tickets'
    | '/articlegroups/$id/$plu'
    | '/articlegroups/$id/'
    | '/account/user/$slug'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/callback'
    | '/$'
    | '/accessibility'
    | '/registermember'
    | '/requestpassword'
    | '/update'
    | '/~offline'
    | '/'
    | '/account'
    | '/account/completedregistration'
    | '/account/register'
    | '/allotments/$id'
    | '/courses/$id'
    | '/products/$plu'
    | '/sale/$token'
    | '/sessions/$id'
    | '/setpassword/$id'
    | '/allotments'
    | '/articlegroups'
    | '/cookies'
    | '/courses'
    | '/products'
    | '/sessions'
    | '/account/activateticket'
    | '/account/bookings'
    | '/account/customerinfo'
    | '/account/history'
    | '/account/password'
    | '/account/photo'
    | '/account/registermanaged'
    | '/account/subscriptions'
    | '/account/tickets'
    | '/articlegroups/$id/$plu'
    | '/articlegroups/$id'
    | '/account/user/$slug'
  id:
    | '__root__'
    | '/_app'
    | '/callback'
    | '/_app/$'
    | '/_app/accessibility'
    | '/_app/account'
    | '/_app/allotments'
    | '/_app/articlegroups'
    | '/_app/courses'
    | '/_app/products'
    | '/_app/registermember'
    | '/_app/requestpassword'
    | '/_app/sessions'
    | '/_app/update'
    | '/_app/~offline'
    | '/_app/'
    | '/_app/account/_auth'
    | '/_app/account/completedregistration'
    | '/_app/account/register'
    | '/_app/allotments/$id'
    | '/_app/articlegroups/$id'
    | '/_app/courses/$id'
    | '/_app/products/$plu'
    | '/_app/sale/$token'
    | '/_app/sessions/$id'
    | '/_app/setpassword/$id'
    | '/_app/account/'
    | '/_app/allotments/'
    | '/_app/articlegroups/'
    | '/_app/cookies/'
    | '/_app/courses/'
    | '/_app/products/'
    | '/_app/sessions/'
    | '/_app/account/_auth/activateticket'
    | '/_app/account/_auth/bookings'
    | '/_app/account/_auth/customerinfo'
    | '/_app/account/_auth/history'
    | '/_app/account/_auth/password'
    | '/_app/account/_auth/photo'
    | '/_app/account/_auth/registermanaged'
    | '/_app/account/_auth/subscriptions'
    | '/_app/account/_auth/tickets'
    | '/_app/articlegroups/$id/$plu'
    | '/_app/articlegroups/$id/'
    | '/_app/account/_auth/user/$slug'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  CallbackRoute: typeof CallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/~offline': {
      id: '/_app/~offline'
      path: '/~offline'
      fullPath: '/~offline'
      preLoaderRoute: typeof AppChar126offlineRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/update': {
      id: '/_app/update'
      path: '/update'
      fullPath: '/update'
      preLoaderRoute: typeof AppUpdateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sessions': {
      id: '/_app/sessions'
      path: '/sessions'
      fullPath: '/sessions'
      preLoaderRoute: typeof AppSessionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/requestpassword': {
      id: '/_app/requestpassword'
      path: '/requestpassword'
      fullPath: '/requestpassword'
      preLoaderRoute: typeof AppRequestpasswordRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/registermember': {
      id: '/_app/registermember'
      path: '/registermember'
      fullPath: '/registermember'
      preLoaderRoute: typeof AppRegistermemberRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products': {
      id: '/_app/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AppProductsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/courses': {
      id: '/_app/courses'
      path: '/courses'
      fullPath: '/courses'
      preLoaderRoute: typeof AppCoursesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/articlegroups': {
      id: '/_app/articlegroups'
      path: '/articlegroups'
      fullPath: '/articlegroups'
      preLoaderRoute: typeof AppArticlegroupsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/allotments': {
      id: '/_app/allotments'
      path: '/allotments'
      fullPath: '/allotments'
      preLoaderRoute: typeof AppAllotmentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accessibility': {
      id: '/_app/accessibility'
      path: '/accessibility'
      fullPath: '/accessibility'
      preLoaderRoute: typeof AppAccessibilityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$': {
      id: '/_app/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AppSplatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sessions/': {
      id: '/_app/sessions/'
      path: '/'
      fullPath: '/sessions/'
      preLoaderRoute: typeof AppSessionsIndexRouteImport
      parentRoute: typeof AppSessionsRoute
    }
    '/_app/products/': {
      id: '/_app/products/'
      path: '/'
      fullPath: '/products/'
      preLoaderRoute: typeof AppProductsIndexRouteImport
      parentRoute: typeof AppProductsRoute
    }
    '/_app/courses/': {
      id: '/_app/courses/'
      path: '/'
      fullPath: '/courses/'
      preLoaderRoute: typeof AppCoursesIndexRouteImport
      parentRoute: typeof AppCoursesRoute
    }
    '/_app/cookies/': {
      id: '/_app/cookies/'
      path: '/cookies'
      fullPath: '/cookies/'
      preLoaderRoute: typeof AppCookiesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/articlegroups/': {
      id: '/_app/articlegroups/'
      path: '/'
      fullPath: '/articlegroups/'
      preLoaderRoute: typeof AppArticlegroupsIndexRouteImport
      parentRoute: typeof AppArticlegroupsRoute
    }
    '/_app/allotments/': {
      id: '/_app/allotments/'
      path: '/'
      fullPath: '/allotments/'
      preLoaderRoute: typeof AppAllotmentsIndexRouteImport
      parentRoute: typeof AppAllotmentsRoute
    }
    '/_app/account/': {
      id: '/_app/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AppAccountIndexRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/setpassword/$id': {
      id: '/_app/setpassword/$id'
      path: '/setpassword/$id'
      fullPath: '/setpassword/$id'
      preLoaderRoute: typeof AppSetpasswordIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sessions/$id': {
      id: '/_app/sessions/$id'
      path: '/$id'
      fullPath: '/sessions/$id'
      preLoaderRoute: typeof AppSessionsIdRouteImport
      parentRoute: typeof AppSessionsRoute
    }
    '/_app/sale/$token': {
      id: '/_app/sale/$token'
      path: '/sale/$token'
      fullPath: '/sale/$token'
      preLoaderRoute: typeof AppSaleTokenRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products/$plu': {
      id: '/_app/products/$plu'
      path: '/$plu'
      fullPath: '/products/$plu'
      preLoaderRoute: typeof AppProductsPluRouteImport
      parentRoute: typeof AppProductsRoute
    }
    '/_app/courses/$id': {
      id: '/_app/courses/$id'
      path: '/$id'
      fullPath: '/courses/$id'
      preLoaderRoute: typeof AppCoursesIdRouteImport
      parentRoute: typeof AppCoursesRoute
    }
    '/_app/articlegroups/$id': {
      id: '/_app/articlegroups/$id'
      path: '/$id'
      fullPath: '/articlegroups/$id'
      preLoaderRoute: typeof AppArticlegroupsIdRouteImport
      parentRoute: typeof AppArticlegroupsRoute
    }
    '/_app/allotments/$id': {
      id: '/_app/allotments/$id'
      path: '/$id'
      fullPath: '/allotments/$id'
      preLoaderRoute: typeof AppAllotmentsIdRouteImport
      parentRoute: typeof AppAllotmentsRoute
    }
    '/_app/account/register': {
      id: '/_app/account/register'
      path: '/register'
      fullPath: '/account/register'
      preLoaderRoute: typeof AppAccountRegisterRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/completedregistration': {
      id: '/_app/account/completedregistration'
      path: '/completedregistration'
      fullPath: '/account/completedregistration'
      preLoaderRoute: typeof AppAccountCompletedregistrationRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/_auth': {
      id: '/_app/account/_auth'
      path: ''
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountAuthRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/articlegroups/$id/': {
      id: '/_app/articlegroups/$id/'
      path: '/'
      fullPath: '/articlegroups/$id/'
      preLoaderRoute: typeof AppArticlegroupsIdIndexRouteImport
      parentRoute: typeof AppArticlegroupsIdRoute
    }
    '/_app/articlegroups/$id/$plu': {
      id: '/_app/articlegroups/$id/$plu'
      path: '/$plu'
      fullPath: '/articlegroups/$id/$plu'
      preLoaderRoute: typeof AppArticlegroupsIdPluRouteImport
      parentRoute: typeof AppArticlegroupsIdRoute
    }
    '/_app/account/_auth/tickets': {
      id: '/_app/account/_auth/tickets'
      path: '/tickets'
      fullPath: '/account/tickets'
      preLoaderRoute: typeof AppAccountAuthTicketsRouteImport
      parentRoute: typeof AppAccountAuthRoute
    }
    '/_app/account/_auth/subscriptions': {
      id: '/_app/account/_auth/subscriptions'
      path: '/subscriptions'
      fullPath: '/account/subscriptions'
      preLoaderRoute: typeof AppAccountAuthSubscriptionsRouteImport
      parentRoute: typeof AppAccountAuthRoute
    }
    '/_app/account/_auth/registermanaged': {
      id: '/_app/account/_auth/registermanaged'
      path: '/registermanaged'
      fullPath: '/account/registermanaged'
      preLoaderRoute: typeof AppAccountAuthRegistermanagedRouteImport
      parentRoute: typeof AppAccountAuthRoute
    }
    '/_app/account/_auth/photo': {
      id: '/_app/account/_auth/photo'
      path: '/photo'
      fullPath: '/account/photo'
      preLoaderRoute: typeof AppAccountAuthPhotoRouteImport
      parentRoute: typeof AppAccountAuthRoute
    }
    '/_app/account/_auth/password': {
      id: '/_app/account/_auth/password'
      path: '/password'
      fullPath: '/account/password'
      preLoaderRoute: typeof AppAccountAuthPasswordRouteImport
      parentRoute: typeof AppAccountAuthRoute
    }
    '/_app/account/_auth/history': {
      id: '/_app/account/_auth/history'
      path: '/history'
      fullPath: '/account/history'
      preLoaderRoute: typeof AppAccountAuthHistoryRouteImport
      parentRoute: typeof AppAccountAuthRoute
    }
    '/_app/account/_auth/customerinfo': {
      id: '/_app/account/_auth/customerinfo'
      path: '/customerinfo'
      fullPath: '/account/customerinfo'
      preLoaderRoute: typeof AppAccountAuthCustomerinfoRouteImport
      parentRoute: typeof AppAccountAuthRoute
    }
    '/_app/account/_auth/bookings': {
      id: '/_app/account/_auth/bookings'
      path: '/bookings'
      fullPath: '/account/bookings'
      preLoaderRoute: typeof AppAccountAuthBookingsRouteImport
      parentRoute: typeof AppAccountAuthRoute
    }
    '/_app/account/_auth/activateticket': {
      id: '/_app/account/_auth/activateticket'
      path: '/activateticket'
      fullPath: '/account/activateticket'
      preLoaderRoute: typeof AppAccountAuthActivateticketRouteImport
      parentRoute: typeof AppAccountAuthRoute
    }
    '/_app/account/_auth/user/$slug': {
      id: '/_app/account/_auth/user/$slug'
      path: '/user/$slug'
      fullPath: '/account/user/$slug'
      preLoaderRoute: typeof AppAccountAuthUserSlugRouteImport
      parentRoute: typeof AppAccountAuthRoute
    }
  }
}

interface AppAccountAuthRouteChildren {
  AppAccountAuthActivateticketRoute: typeof AppAccountAuthActivateticketRoute
  AppAccountAuthBookingsRoute: typeof AppAccountAuthBookingsRoute
  AppAccountAuthCustomerinfoRoute: typeof AppAccountAuthCustomerinfoRoute
  AppAccountAuthHistoryRoute: typeof AppAccountAuthHistoryRoute
  AppAccountAuthPasswordRoute: typeof AppAccountAuthPasswordRoute
  AppAccountAuthPhotoRoute: typeof AppAccountAuthPhotoRoute
  AppAccountAuthRegistermanagedRoute: typeof AppAccountAuthRegistermanagedRoute
  AppAccountAuthSubscriptionsRoute: typeof AppAccountAuthSubscriptionsRoute
  AppAccountAuthTicketsRoute: typeof AppAccountAuthTicketsRoute
  AppAccountAuthUserSlugRoute: typeof AppAccountAuthUserSlugRoute
}

const AppAccountAuthRouteChildren: AppAccountAuthRouteChildren = {
  AppAccountAuthActivateticketRoute: AppAccountAuthActivateticketRoute,
  AppAccountAuthBookingsRoute: AppAccountAuthBookingsRoute,
  AppAccountAuthCustomerinfoRoute: AppAccountAuthCustomerinfoRoute,
  AppAccountAuthHistoryRoute: AppAccountAuthHistoryRoute,
  AppAccountAuthPasswordRoute: AppAccountAuthPasswordRoute,
  AppAccountAuthPhotoRoute: AppAccountAuthPhotoRoute,
  AppAccountAuthRegistermanagedRoute: AppAccountAuthRegistermanagedRoute,
  AppAccountAuthSubscriptionsRoute: AppAccountAuthSubscriptionsRoute,
  AppAccountAuthTicketsRoute: AppAccountAuthTicketsRoute,
  AppAccountAuthUserSlugRoute: AppAccountAuthUserSlugRoute,
}

const AppAccountAuthRouteWithChildren = AppAccountAuthRoute._addFileChildren(
  AppAccountAuthRouteChildren,
)

interface AppAccountRouteChildren {
  AppAccountAuthRoute: typeof AppAccountAuthRouteWithChildren
  AppAccountCompletedregistrationRoute: typeof AppAccountCompletedregistrationRoute
  AppAccountRegisterRoute: typeof AppAccountRegisterRoute
  AppAccountIndexRoute: typeof AppAccountIndexRoute
}

const AppAccountRouteChildren: AppAccountRouteChildren = {
  AppAccountAuthRoute: AppAccountAuthRouteWithChildren,
  AppAccountCompletedregistrationRoute: AppAccountCompletedregistrationRoute,
  AppAccountRegisterRoute: AppAccountRegisterRoute,
  AppAccountIndexRoute: AppAccountIndexRoute,
}

const AppAccountRouteWithChildren = AppAccountRoute._addFileChildren(
  AppAccountRouteChildren,
)

interface AppAllotmentsRouteChildren {
  AppAllotmentsIdRoute: typeof AppAllotmentsIdRoute
  AppAllotmentsIndexRoute: typeof AppAllotmentsIndexRoute
}

const AppAllotmentsRouteChildren: AppAllotmentsRouteChildren = {
  AppAllotmentsIdRoute: AppAllotmentsIdRoute,
  AppAllotmentsIndexRoute: AppAllotmentsIndexRoute,
}

const AppAllotmentsRouteWithChildren = AppAllotmentsRoute._addFileChildren(
  AppAllotmentsRouteChildren,
)

interface AppArticlegroupsIdRouteChildren {
  AppArticlegroupsIdPluRoute: typeof AppArticlegroupsIdPluRoute
  AppArticlegroupsIdIndexRoute: typeof AppArticlegroupsIdIndexRoute
}

const AppArticlegroupsIdRouteChildren: AppArticlegroupsIdRouteChildren = {
  AppArticlegroupsIdPluRoute: AppArticlegroupsIdPluRoute,
  AppArticlegroupsIdIndexRoute: AppArticlegroupsIdIndexRoute,
}

const AppArticlegroupsIdRouteWithChildren =
  AppArticlegroupsIdRoute._addFileChildren(AppArticlegroupsIdRouteChildren)

interface AppArticlegroupsRouteChildren {
  AppArticlegroupsIdRoute: typeof AppArticlegroupsIdRouteWithChildren
  AppArticlegroupsIndexRoute: typeof AppArticlegroupsIndexRoute
}

const AppArticlegroupsRouteChildren: AppArticlegroupsRouteChildren = {
  AppArticlegroupsIdRoute: AppArticlegroupsIdRouteWithChildren,
  AppArticlegroupsIndexRoute: AppArticlegroupsIndexRoute,
}

const AppArticlegroupsRouteWithChildren =
  AppArticlegroupsRoute._addFileChildren(AppArticlegroupsRouteChildren)

interface AppCoursesRouteChildren {
  AppCoursesIdRoute: typeof AppCoursesIdRoute
  AppCoursesIndexRoute: typeof AppCoursesIndexRoute
}

const AppCoursesRouteChildren: AppCoursesRouteChildren = {
  AppCoursesIdRoute: AppCoursesIdRoute,
  AppCoursesIndexRoute: AppCoursesIndexRoute,
}

const AppCoursesRouteWithChildren = AppCoursesRoute._addFileChildren(
  AppCoursesRouteChildren,
)

interface AppProductsRouteChildren {
  AppProductsPluRoute: typeof AppProductsPluRoute
  AppProductsIndexRoute: typeof AppProductsIndexRoute
}

const AppProductsRouteChildren: AppProductsRouteChildren = {
  AppProductsPluRoute: AppProductsPluRoute,
  AppProductsIndexRoute: AppProductsIndexRoute,
}

const AppProductsRouteWithChildren = AppProductsRoute._addFileChildren(
  AppProductsRouteChildren,
)

interface AppSessionsRouteChildren {
  AppSessionsIdRoute: typeof AppSessionsIdRoute
  AppSessionsIndexRoute: typeof AppSessionsIndexRoute
}

const AppSessionsRouteChildren: AppSessionsRouteChildren = {
  AppSessionsIdRoute: AppSessionsIdRoute,
  AppSessionsIndexRoute: AppSessionsIndexRoute,
}

const AppSessionsRouteWithChildren = AppSessionsRoute._addFileChildren(
  AppSessionsRouteChildren,
)

interface AppRouteChildren {
  AppSplatRoute: typeof AppSplatRoute
  AppAccessibilityRoute: typeof AppAccessibilityRoute
  AppAccountRoute: typeof AppAccountRouteWithChildren
  AppAllotmentsRoute: typeof AppAllotmentsRouteWithChildren
  AppArticlegroupsRoute: typeof AppArticlegroupsRouteWithChildren
  AppCoursesRoute: typeof AppCoursesRouteWithChildren
  AppProductsRoute: typeof AppProductsRouteWithChildren
  AppRegistermemberRoute: typeof AppRegistermemberRoute
  AppRequestpasswordRoute: typeof AppRequestpasswordRoute
  AppSessionsRoute: typeof AppSessionsRouteWithChildren
  AppUpdateRoute: typeof AppUpdateRoute
  AppChar126offlineRoute: typeof AppChar126offlineRoute
  AppIndexRoute: typeof AppIndexRoute
  AppSaleTokenRoute: typeof AppSaleTokenRoute
  AppSetpasswordIdRoute: typeof AppSetpasswordIdRoute
  AppCookiesIndexRoute: typeof AppCookiesIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSplatRoute: AppSplatRoute,
  AppAccessibilityRoute: AppAccessibilityRoute,
  AppAccountRoute: AppAccountRouteWithChildren,
  AppAllotmentsRoute: AppAllotmentsRouteWithChildren,
  AppArticlegroupsRoute: AppArticlegroupsRouteWithChildren,
  AppCoursesRoute: AppCoursesRouteWithChildren,
  AppProductsRoute: AppProductsRouteWithChildren,
  AppRegistermemberRoute: AppRegistermemberRoute,
  AppRequestpasswordRoute: AppRequestpasswordRoute,
  AppSessionsRoute: AppSessionsRouteWithChildren,
  AppUpdateRoute: AppUpdateRoute,
  AppChar126offlineRoute: AppChar126offlineRoute,
  AppIndexRoute: AppIndexRoute,
  AppSaleTokenRoute: AppSaleTokenRoute,
  AppSetpasswordIdRoute: AppSetpasswordIdRoute,
  AppCookiesIndexRoute: AppCookiesIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  CallbackRoute: CallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
